import { AuthGuard } from "./app-route.guard";
import { Routes, RouterModule } from "@angular/router";
import { HomeComponent } from "./components/home/home.component";
import { LoginComponent } from "./components/login/login.component";
import { SignupComponent } from "./components/signup/signup.component";
import { CorporateAdminComponent } from "./components/CorporateAdmin/corporateAdmin.component";
import { MyProfileComponent } from "./components/my-profile/my-profile.component";
import { ProductComponent } from "./components/product/product.component";
import { CategoryComponent } from "./components/category/category.component";
import { ProductAllComponent } from "./components/ProductAll/ProductAll.component";
import { OffersComponent } from "./components/offers/offers.component";
import { NotFoundComponent } from "./components/not-found/not-found.component";
import { ForgotPasswordComponent } from "./components/forgot-password/forgot-password.component";
import { OfferDetailComponent } from "./components/offer-detail/offer-detail.component";
import { CartComponent } from "./components/cart/cart.component";
import { OrdersComponent } from "./components/orders/orders.component";
import { OrderDetailComponent } from "./components/orders/order-detail/order-detail.component";
import { IssuesComponent } from "./components/orders/issues/issues.component";
import { StoreUserLoginComponent } from "./components/store-user-login/store-user-login.component";
import { AboutUsComponent } from "./components/additional-pages/about-us/about-us.component";
import { PrivacyPolicyComponent } from "./components/additional-pages/privacy-policy/privacy-policy.component";
import { ContactUsComponent } from "./components/additional-pages/contact-us/contact-us.component";
import { ExchangePolicyComponent } from "./components/additional-pages/exchange-policy/exchange-policy.component";
import { FaqComponent } from "./components/additional-pages/faq/faq.component";
import { ShippingPolicyComponent } from "./components/additional-pages/shipping-policy/shipping-policy.component";
import { TermsAndConditionsComponent } from "./components/additional-pages/terms-and-conditions/terms-and-conditions.component";
import { CheckoutComponent } from "./components/checkout/checkout.component";
import { SuccessfulOrderComponent } from "./components/successful-order/successful-order.component";
import { ResetPasswordComponent } from "./components/reset-password/reset-password.component";
import { TopSellingProductsComponent } from "./components/top-selling-products/top-selling-products.component";
import { TopOfferProductsComponent } from "./components/top-offer-products/top-offer-products.component";
import { VerifyOtpComponent } from "./components/verify-otp/verify-otp.component";
import { BrandDetailComponent } from "./components/brand-detail/brand-detail.component";
import { TermsComponent } from "./components/referral-terms/terms.component";
import { ReferralComponent } from "./components/referral/referral.component";
import { BannerProductAllComponent } from "./components/Banner-product-all/Banner-product-all.component";
import { DataDeletionComponent } from "./components/additional-pages/data-deletion/data-deletion.component";
export const appRoutes: Routes = [
  { path: "", component: HomeComponent },
  { path: "login", component: LoginComponent },
  { path: "StoreUserLogin", component: StoreUserLoginComponent },
  { path: "product/:id", component: ProductComponent },
  { path: "forgot-password", component: ForgotPasswordComponent },
  { path: "signup", component: SignupComponent },

  { path: "corporateAdmin", component: CorporateAdminComponent },
  { path: "category/:id", component: CategoryComponent },
  { path: "ProductAll/:str", component: ProductAllComponent },
  { path: "offers", component: OffersComponent },
  { path: "offerdetail/:id", component: OfferDetailComponent },
  { path: "cart", component: CartComponent },
  { path: "about-us", component: AboutUsComponent },
  { path: "privacy-policy", component: PrivacyPolicyComponent },
  {path: "data-deletion", component: DataDeletionComponent},
  { path: "contact-us", component: ContactUsComponent },
  { path: "exchange-policy", component: ExchangePolicyComponent },
  { path: "faq", component: FaqComponent },
  { path: "shipping-policy", component: ShippingPolicyComponent },
  { path: "terms-and-conditions", component: TermsAndConditionsComponent },
  { path: "reset-password", component: ResetPasswordComponent },
  { path: "top-selling-products", component: TopSellingProductsComponent },
  { path: "top-offer-products", component: TopOfferProductsComponent },
  { path: "verify-otp", component: VerifyOtpComponent },
  { path: "brand-detail/:id", component: BrandDetailComponent },
  { path: "referral-terms", component: TermsComponent },
  { path: "referral", component: ReferralComponent },
  {
    path: "Banner-product-all/:id",
    component: BannerProductAllComponent,
    data: { some_data: "some value" }
  },
  { path: "Login/ResetPassword", component: ResetPasswordComponent },
  {
    path: "",
    runGuardsAndResolvers: "always",
    canActivate: [AuthGuard],
    children: [
      { path: "MyProfile", component: MyProfileComponent },
      { path: "orders", component: OrdersComponent },
      { path: "issues/:id", component: IssuesComponent },
      { path: "checkout", component: CheckoutComponent },
      { path: "successful-order", component: SuccessfulOrderComponent },
      {
        path: "StoreUser",
        loadChildren: "./store-user/store-user.module#StoreUserModule"
      }
    ]
  },
  {
    path: "",
    runGuardsAndResolvers: "always",
    children: [
      { path: "orderdetail/:id", component: OrderDetailComponent },
    ]
  },
  { path: "**", component: NotFoundComponent }
];



// WEBPACK FOOTER //
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/app-route.ts